export const ADMIN_OVERRIDE_STORAGE_KEY = 'altessera.admin.enabled';

const LOCALHOST_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

const toBool = (value) => String(value || '').trim().toLowerCase() === 'true';

export const isAdminEnabled = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = String(window.location.hostname || '').trim().toLowerCase();
  const isLocalhost = LOCALHOST_HOSTS.has(hostname);
  const isEnvEnabled = toBool(process.env.REACT_APP_ENABLE_ADMIN);
  const isStorageOverrideEnabled = toBool(window.localStorage.getItem(ADMIN_OVERRIDE_STORAGE_KEY));

  return isLocalhost || isEnvEnabled || isStorageOverrideEnabled;
};
